var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCameraFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.75V17.25C18 17.6478 17.842 18.0294 17.5607 18.3107C17.2794 18.592 16.8978 18.75 16.5 18.75H3C2.60218 18.75 2.22064 18.592 1.93934 18.3107C1.65804 18.0294 1.5 17.6478 1.5 17.25V6.75C1.5 6.35218 1.65804 5.97064 1.93934 5.68934C2.22064 5.40804 2.60218 5.25 3 5.25H16.5C16.8978 5.25 17.2794 5.40804 17.5607 5.68934C17.842 5.97064 18 6.35218 18 6.75ZM23.4375 6.77344C23.3317 6.74755 23.2216 6.74435 23.1145 6.76406C23.0073 6.78378 22.9056 6.82595 22.8159 6.88781L19.6669 8.98688C19.6155 9.02115 19.5734 9.06758 19.5443 9.12204C19.5152 9.1765 19.5 9.23731 19.5 9.29906V14.7009C19.5 14.7627 19.5152 14.8235 19.5443 14.878C19.5734 14.9324 19.6155 14.9789 19.6669 15.0131L22.8337 17.1244C22.9523 17.2034 23.0909 17.2471 23.2333 17.2503C23.3758 17.2534 23.5162 17.2159 23.6381 17.1422C23.7509 17.0705 23.8434 16.971 23.9068 16.8533C23.9702 16.7356 24.0022 16.6036 24 16.47V7.5C24.0001 7.33366 23.9449 7.17202 23.843 7.04049C23.7412 6.90897 23.5986 6.81502 23.4375 6.77344Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCameraFilled);
export default __webpack_public_path__ + "static/media/video-camera-filled.0397ad0daa5bb424750fe41968c06ece.svg";
export { ForwardRef as ReactComponent };